'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _functional = require('../utils/functional');

var _lazyImages = require('../setup/lazy-images');

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// TODO: Remove querystring
var LoadMore = function () {
  function LoadMore(_ref) {
    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, LoadMore);

    this.el = el;
    this.context = context;

    if (this.els.pagination == null) return;

    this.setupListeners();

    this._loading = false;
    this._hasBeenClicked = false;
    this.currentPage = this.initialState.currentPage;
    this.loadingPage = this.currentPage;
    this.loadingPageContent = null;
  }

  (0, _createClass3.default)(LoadMore, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();

      this.onClick = this.onClick.bind(this);

      this.listeners.add(this.els.trigger, 'click', this.onClick);
    }
  }, {
    key: 'onClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var parsedQuerystring, response, data;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.loading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!(this.currentPage !== this.loadingPage)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:

                this.hasBeenClicked = true;
                this.loading = true;
                this.loadingPage = this.currentPage + 1;

                parsedQuerystring = (0, _assign2.default)({}, this.parsedQueryString);

                parsedQuerystring.page = this.loadingPage;

                _context.next = 11;
                return fetch(this.initialState.url + '?' + _queryString2.default.stringify(parsedQuerystring));

              case 11:
                response = _context.sent;
                _context.next = 14;
                return response.text();

              case 14:
                data = _context.sent;

                this.loading = false;
                this.loadingPageContent = data;
                this.els.trigger.blur();

                this.insertContent();

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onClick() {
        return _ref2.apply(this, arguments);
      }

      return onClick;
    }()
  }, {
    key: 'insertContent',
    value: function insertContent() {
      if (!this.hasBeenClicked) return;
      if (this.loadingPageContent == null) return;

      var fragment = document.createDocumentFragment();
      var div = (0, _functional.createElement)('div');
      div.innerHTML = this.loadingPageContent;
      var newElements = (0, _functional.getElements)(this.initialState.itemClassName, { context: div });
      newElements.forEach(function (item) {
        fragment.appendChild(item);
      });

      this.els.target.appendChild(fragment);

      var shouldUpdateCurrentAmountViewed = this.els.text != null;

      if (shouldUpdateCurrentAmountViewed) {
        this.setCurrentAmountViewed();
      }

      this.currentPage = this.loadingPage;
      this.loadingPageContent = null;
      this.hasBeenClicked = false;

      // Adds new images to lazyloading event listener
      (0, _lazyImages.updateImages)();
      (0, _lazyImages.setImages)();
    }
  }, {
    key: 'setCurrentAmountViewed',
    value: function setCurrentAmountViewed() {
      var hasExcludeClasses = this.initialState.itemClassNameToExclude !== undefined;
      var classesToFind = hasExcludeClasses ? this.initialState.itemClassName + ':not(' + this.initialState.itemClassNameToExclude + ')' : '' + this.initialState.itemClassName;

      var currentTotal = (0, _functional.getElements)(classesToFind).length;
      var totalCount = this.initialState.totalItems;
      this.els.text.innerText = this.initialState.textTemplate.replace('{{ pagination_amount }}', currentTotal).replace('{{ total_count }}', totalCount);

      if (currentTotal === this.initialState.totalItems) {
        this.els.pagination.remove();
      }
    }
  }, {
    key: 'afterLoaded',
    value: function afterLoaded() {
      if (this.loading === false && this.hasBeenClicked) {
        this.insertContent();
      }
    }
  }, {
    key: 'parsedQueryString',
    get: function get() {
      return _queryString2.default.parse(window.location.search);
    }
  }, {
    key: 'initialState',
    get: function get() {
      return {
        itemClassName: this.el.dataset.itemClassName,
        itemClassNameToExclude: this.el.dataset.itemClassNameToExclude,
        perPage: parseInt(this.el.dataset.perPage, 10),
        currentPage: parseInt(this.el.dataset.currentPage, 10),
        textTemplate: this.el.dataset.textTemplate,
        totalItems: parseInt(this.el.dataset.totalItems, 10),
        url: this.el.dataset.url
      };
    }
  }, {
    key: 'els',
    get: function get() {
      return {
        el: this.el,
        target: this.context.getElement('.' + this.context.className + '_Target'),
        pagination: this.context.getElement('.' + this.context.className + '_Pagination'),
        text: this.context.getElement('.' + this.context.className + '_Text'),
        trigger: this.context.getElement('.' + this.context.className + '_Trigger')
      };
    }
  }, {
    key: 'hasBeenClicked',
    get: function get() {
      return this._hasBeenClicked;
    },
    set: function set(val) {
      this._hasBeenClicked = val;

      this.els.el.classList.toggle(this.context.className + '-loading', val && this.loading);
    }
  }, {
    key: 'loading',
    get: function get() {
      return this._loading;
    },
    set: function set(val) {
      this._loading = val;

      this.els.el.classList.toggle(this.context.className + '-loading', val && this.hasBeenClicked);

      this.afterLoaded();
    }
  }]);
  return LoadMore;
}();

function init(_ref3) {
  var el = _ref3.el,
      context = _ref3.context;

  // eslint-disable-next-line no-new
  new LoadMore({ el: el, context: context });
}